export const delay = (timeout = 0): Promise<void> => new Promise((resolve) => setTimeout(resolve, timeout));

interface PollUntilOptions<T> {
  request: () => Promise<T>;
  shouldStop: (value: T) => boolean;
  interval: number;
  maxAttempts: number;
}

export const pollUntil = async <T>({
  request,
  shouldStop,
  interval,
  maxAttempts,
}: PollUntilOptions<T>): Promise<T | undefined> => {
  for (let attemptNumber = 0; attemptNumber < maxAttempts; attemptNumber += 1) {
    await delay(interval);

    const value = await request();

    if (shouldStop(value)) return value;
  }

  return undefined;
};
